export const zh = {
  layout: {
    hello: '欢迎光临陆海新通道国际工商会联盟！'
  },
  moduleTitle: {
    news: '新闻动态',
    activity: '重要活动',
    notice: '联盟公告',
    project: '合作项目推荐',
    report: '投资报告书',
    member: '联盟成员',
    partner: '合作伙伴',
    link: '友情链接'
  },
  common: {
    noData: '暂无数据',
    searchPlaceholder: '请输入关键字查询',
    search: '搜索'
  }
}


// WEBPACK FOOTER //
// ./src/assets/langs/zh.js